import { getFeatureFlags, setFeatureFlags } from '../client';
import type { FeatureFlagsUpdate } from '../client';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useSimulationId } from './useSimulationId';

export function useServerFeatureFlags() {
  const simId = useSimulationId();

  const query = useQuery({
    queryKey: ['feature-flags', simId],
    queryFn: () => getFeatureFlags({ path: { sim_id: simId }, throwOnError: true }).then(({ data }) => data),
    refetchInterval: 60_000,
  });

  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (data: { requestBody: FeatureFlagsUpdate }) =>
      setFeatureFlags({ path: { sim_id: simId }, body: data.requestBody, throwOnError: true }).then(({ data }) => data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['feature-flags', simId] });
    },
  });

  return { mutate: mutation.mutate, mutateAsync: mutation.mutateAsync, ...query };
}
